import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { MapPropsDefault } from 'client/components/Map/mapPropsDefault'
import { PropsMapHook } from 'client/components/Map/types'

import { Objects } from 'utils/objects'

export const useRestoreSnapshot = (props: PropsMapHook): void => {
  const { loaded, mapRef, snapshotRef } = props

  const { pathname } = useLocation()

  useEffect(() => {
    if (!loaded) return

    const snapshot = snapshotRef.current

    if (pathname === '/') {
      const map = mapRef.current!.getMap()

      if (Objects.isNil(snapshot)) {
        map.flyTo({
          center: [MapPropsDefault.initialViewState.longitude!, MapPropsDefault.initialViewState.latitude!],
          duration: 0,
          zoom: MapPropsDefault.initialViewState.zoom,
        })
      } else {
        map.flyTo({
          bearing: snapshot.bearing,
          center: [snapshot.lng, snapshot.lat],
          duration: 0,
          pitch: snapshot.pitch,
          zoom: snapshot.zoom,
        })
        snapshotRef.current = null
      }
    }
  }, [loaded, mapRef, pathname, snapshotRef])
}
